import 'vue-select/dist/vue-select.css'
import CompatVSelect from '../components/shared/CompatVSelect'

export default {
  install(app) {
    app.component('v-select', CompatVSelect)
  }
}
